var exports = {
  "i": "xaee3c4fa--34fe57--wrapper",
};

module.exports = exports;
